import { ThemeProvider } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { differenceInDays, format } from "date-fns";
import React, { Fragment, useEffect } from "react";
import { AuthContext } from "../../App";
import { downloadListarContainersUpload, listarContainersUpload } from "../../services/ContainerService";
import { Pagina } from "../template/Template";

import DateFnsUtils from "@date-io/date-fns";
import { Button } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Paper from "@material-ui/core/Paper";
import Switch from "@material-ui/core/Switch";
import {
    DataGrid,
    GridFilterToolbarButton,
    GridToolbarContainer,
} from "@material-ui/data-grid";
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import SaveAlt from "@mui/icons-material/SaveAlt";
import ptBR2 from "date-fns/locale/pt-BR";

import { Formik } from "formik";
import { Loading } from "../Loading";

import TextField from "@material-ui/core/TextField";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { ShowMessageBox } from "../ShowMessageBox";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import { clienteFindAllByUsuId } from "../../services/ClienteService";
import { siteFindByUsuId } from "../../services/SiteService";

import { useStyles } from "../styles/StyleSituacaoUpload";
import { theme } from "../styles/Theme";

var MS_PER_DAY = 60000 * 60 * 24;

let severity = "success";
let msg = "";

export default function SituacaoUpload() {
    const classes = useStyles();
    const { state: authState } = React.useContext(AuthContext);
    const [listCliente, setListCliente] = React.useState([]);
    const [listSite, setListSite] = React.useState([]);
    useEffect(async () => {
        const respCliente = await clienteFindAllByUsuId();
        const respSite = await siteFindByUsuId();
        setListCliente(respCliente.data);
        setListSite(respSite.data);
    }, []);


    const Content = () => {
        const [openSnackBar, setOpenSnackBar] = React.useState(false);
        const [listContainers, setListContainers] = React.useState([]);
        const [openLoading, setOpenLoading] = React.useState(false);


        const CustomToolbar = () => {
            return (
                <GridToolbarContainer style={{ justifyContent: "space-between" }}>
                    <GridFilterToolbarButton />
                </GridToolbarContainer>
            );
        };

        return (
            <Fragment>
                <Formik
                    initialValues={{
                        dataInicial: new Date(new Date().getTime() - 30 * MS_PER_DAY),
                        dataFinal: new Date(),
                        conId: "",
                        cliId: "0",
                        trkId: "",
                        sitId: "",
                        operacao: "Todos",
                        vepSituacaoEnvio: "Todos",
                        pendentes: false,
                    }}
                    validate={(values) => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                        setOpenSnackBar(false);
                        const diffInDays = differenceInDays(
                            values.dataFinal,
                            values.dataInicial
                        );
                        let dtif;
                        let dtff;

                        if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                            severity = "error";
                            msg = "Data inicial maior que data final";
                            setOpenSnackBar(true);
                            return;
                        } else if (diffInDays > 365) {
                            severity = "error";
                            msg = "Ops, intervalos maiores que 365 dias não são permitidos";
                            setOpenSnackBar(true);
                            return;
                        }

                        dtif = format(values.dataInicial, "yyyy-MM-dd") + "'T'00:00:00";
                        dtff = format(values.dataFinal, "yyyy-MM-dd") + "'T'23:59:59";

                        setOpenLoading(true);

                        console.log(
                            values.operacao,
                            dtif,
                            dtff,
                            values.conId,
                            values.sitId,
                        );

                        const list = await listarContainersUpload(
                            values.operacao,
                            dtif,
                            dtff,
                            values.conId,
                            values.trkId,
                            values.sitId,
                            values.cliId,
                            values.vepSituacaoEnvio,
                            values.pendentes
                        );

                        setListContainers(list.data);
                        setOpenLoading(false);
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form
                            onSubmit={handleSubmit}
                            className={classes.form}
                            style={{ display: "flex" }}
                        >
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <ShowMessageBox
                                        open={openSnackBar}
                                        setOpen={setOpenSnackBar}
                                        severity={severity}
                                        msg={msg}
                                    />
                                    <Loading open={openLoading} />
                                    <div className={classes.dashboard_header}>
                                        <div className={classes.dashboard_header_status}>
                                            <div className={classes.center_data}>
                                                {/* //* Dropdown operacao do container */}
                                                <FormControl className={classes.operacao}>
                                                    <InputLabel id="label-operacao">Operação</InputLabel>
                                                    <Select
                                                        labelId="label-operacao"
                                                        id="operacao"
                                                        name="operacao"
                                                        value={values.operacao}
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem key="" value="Todos">
                                                            Todos
                                                        </MenuItem>
                                                        <MenuItem key="Suspeito" value="Suspeito">
                                                            Suspeito
                                                        </MenuItem>
                                                        <MenuItem key="Aprovado" value="Aprovado">
                                                            Aprovado
                                                        </MenuItem>
                                                        <MenuItem key="Inconsistente" value="Inconsistente">
                                                            Inconsistente
                                                        </MenuItem>
                                                        <MenuItem key="Pendente" value="Pendente">
                                                            Pendente
                                                        </MenuItem>
                                                        <MenuItem key="Desativado" value="Desativado">
                                                            Desativado
                                                        </MenuItem>
                                                        <MenuItem key="Indefinido" value="Indefinido">
                                                            Indefinido
                                                        </MenuItem>
                                                        <MenuItem key="Erro" value="Erro">
                                                            Erro
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>

                                                <FormControl className={classes.operacao}>
                                                    <InputLabel id="label-situacaoenvio">Situação Envio</InputLabel>
                                                    <Select
                                                        labelId="label-situacaoenvio"
                                                        id="vepSituacaoEnvio"
                                                        name="vepSituacaoEnvio"
                                                        value={values.vepSituacaoEnvio}
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem key="" value="Todos">
                                                            Todos
                                                        </MenuItem>
                                                        <MenuItem key="SemPendentes" value="SemPendentes">
                                                            Sem Pendentes
                                                        </MenuItem>
                                                        <MenuItem key="EnvioPendente" value="EnvioPendente">
                                                            Envio Pendente
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>

                                                {/* //* TEXT FIELD */}
                                                <TextField
                                                    value={values.conId}
                                                    id="conId"
                                                    name="conId"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Container"
                                                    className={classes.container}
                                                    helperText={errors.conId}
                                                />
                                                <TextField
                                                    value={values.trkId}
                                                    id="trkId"
                                                    name="trkId"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Truck Id"
                                                    className={classes.trkId}
                                                    helperText={errors.trkId}
                                                />

                                                {/* //* TEXT FIELD */}
                                                <FormControl className={classes.site}>
                                                    <InputLabel id="label-cliente">Cliente</InputLabel>
                                                    <Select
                                                        labelId="label-cliente"
                                                        id="cliId"
                                                        name="cliId"
                                                        value={values.cliId}
                                                        className={classes.cliId}
                                                        //autoWidth
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem key="" value="0">
                                                            Nenhum...
                                                        </MenuItem>

                                                        {listCliente.map((cliente) => (
                                                            <MenuItem
                                                                key={cliente.cli_id}
                                                                value={cliente.cli_id}
                                                            >
                                                                {cliente.cli_nome}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>

                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={values.pendentes}
                                                            name="pendentes"
                                                            color="primary"
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}

                                                        />
                                                    }
                                                    label="Pendentes"
                                                    labelPlacement="top"
                                                    sx={{ alignItems: 'center' }}
                                                />


                                                <FormControl className={classes.site}>
                                                    <InputLabel id="label-site">Site</InputLabel>
                                                    <Select
                                                        labelId="label-site"
                                                        id="sitId"
                                                        name="sitId"
                                                        value={values.sitId}
                                                        className={classes.cliId}
                                                        //autoWidth
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem key="" value="">
                                                            Nenhum...
                                                        </MenuItem>

                                                        {listSite.map((site) => (
                                                            <MenuItem
                                                                key={site.sit_id}
                                                                value={site.sit_id}
                                                            >
                                                                {site.sit_nome}({site.sit_id})
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>

                                            </div>
                                        </div>

                                        <div className={classes.center_data}>
                                            <div className={classes.dashboard_header_filtro}>
                                                {/* <span style={{ marginRight: "20px" }}>Período:</span> */}
                                                <MuiPickersUtilsProvider
                                                    locale={ptBR2}
                                                    utils={DateFnsUtils}
                                                >
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        format="dd/MM/yyyy"
                                                        id="dataInicial"
                                                        name="dataInicial"
                                                        value={values.dataInicial}
                                                        onChange={(val) => {
                                                            setFieldValue("dataInicial", val);
                                                            //const dataFim = addDays(val, 7);
                                                            //setFieldValue("dataFinal", dataFim);
                                                        }}
                                                        onBlur={handleBlur}
                                                        style={{ width: "150px", marginRight: "30px" }}
                                                        KeyboardButtonProps={{
                                                            "aria-label": "change date",
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>

                                                <MuiPickersUtilsProvider
                                                    locale={ptBR2}
                                                    utils={DateFnsUtils}
                                                >
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        format="dd/MM/yyyy"
                                                        value={values.dataFinal}
                                                        style={{ width: "150px", marginRight: "30px" }}
                                                        id="dataFinal"
                                                        name="dataFinal"
                                                        onChange={(val) => {
                                                            setFieldValue("dataFinal", val);
                                                            //const dataInicio = addDays(val, -7);
                                                            //setFieldValue("dataInicial", dataInicio);
                                                        }}
                                                        onBlur={handleBlur}
                                                        KeyboardButtonProps={{
                                                            "aria-label": "change date",
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>

                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    type="submit"
                                                    style={{ fontWeight: "bold" }}
                                                >
                                                    <FilterAltIcon />
                                                </Button>
                                                <Tooltip title="Exportar para Excel">
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            const diffInDays = differenceInDays(
                                                                values.dataFinal,
                                                                values.dataInicial
                                                            );
                                                            let dtif;
                                                            let dtff;

                                                            if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                                                                severity = "error";
                                                                msg = "Data inicial maior que data final";
                                                                setOpenSnackBar(true);
                                                                return;
                                                            } else if (diffInDays > 365) {
                                                                severity = "error";
                                                                msg = "Ops, intervalos maiores que 365 dias não são permitidos";
                                                                setOpenSnackBar(true);
                                                                return;
                                                            }

                                                            dtif = format(values.dataInicial, "yyyy-MM-dd") + "'T'00:00:00";
                                                            dtff = format(values.dataFinal, "yyyy-MM-dd") + "'T'23:59:59";

                                                            downloadListarContainersUpload(values.operacao,
                                                                dtif,
                                                                dtff,
                                                                values.conId,
                                                                values.trkId,
                                                                values.sitId,
                                                                values.cliId,
                                                                values.vepSituacaoEnvio,
                                                                values.pendentes
                                                            )
                                                        }}
                                                        disabled={listContainers.length === 0}
                                                        style={{ fontWeight: "bold", marginLeft: "10px" }}
                                                        Tooltip="Gerar a planilha xlsx"
                                                    >
                                                        <SaveAlt />
                                                    </Button>
                                                </Tooltip>

                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.boxDataGrid}>
                                            <ThemeProvider theme={theme}>
                                                <DataGrid
                                                    rows={listContainers}
                                                    disableColumnMenu
                                                    hin
                                                    rowHeight={40}
                                                    disableColumnReorder
                                                    id="id"
                                                    components={{
                                                        Toolbar: CustomToolbar,
                                                    }}
                                                    columns={[
                                                        {
                                                            field: "trk_id",
                                                            headerName: "Truck ID",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 230,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "sit_id",
                                                            headerName: "Site ID",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 170,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "con_id",
                                                            headerName: "Containder ID",
                                                            headerClassName: "header_grid",
                                                            type: "number",
                                                            headerAlign: "center",
                                                            width: 170,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "cov_id",
                                                            headerName: "Operação ID",
                                                            headerClassName: "header_grid",
                                                            type: "number",
                                                            headerAlign: "center",
                                                            width: 170,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "con_container",
                                                            headerName: "Container",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 250,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "cli_nome",
                                                            headerName: "Cliente",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 170,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "sit_nome",
                                                            headerName: "Site",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 170,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "sid_sit_upload_cliente",
                                                            headerName: "Upload Cli",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "sid_sit_upload_ebco",
                                                            headerName: "Upload Ebco",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "sid_situacao_upload",
                                                            headerName: "Upload",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            align: "center",
                                                            width: 170,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "data_operador_porto",
                                                            headerName: "Dt.Ver.Terminal",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "con_ai_data",
                                                            headerName: "Con IA Data",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "con_data_entrada",
                                                            headerName: "Entrada",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "con_data_scan",
                                                            headerName: "Scan",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "con_placa_vehicle",
                                                            headerName: "Placa Veículo",
                                                            type: "string",
                                                            headerClassName: "header_grid",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "con_placa_trailer",
                                                            headerName: "Placa Trailer",
                                                            type: "string",
                                                            headerClassName: "header_grid",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "sid_dt_fase_1",
                                                            headerName: "Fase 1",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 140,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "sid_dt_fase_2",
                                                            headerName: "Fase 2",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 140,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "sid_dt_fase_3",
                                                            headerName: "Fase 3",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 140,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "sid_dt_fase_4",
                                                            headerName: "Fase 4",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 140,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "sid_dt_fase_5",
                                                            headerName: "Fase 5",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 140,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "sid_dt_fase_6",
                                                            headerName: "Fase 6",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 140,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "sid_dt_fase_7",
                                                            headerName: "Fase 7",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 140,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "con_situacao",
                                                            headerName: "Situação",
                                                            type: "string",
                                                            headerClassName: "header_grid",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "vep_situacao_envio",
                                                            headerName: "Situação Envio",
                                                            type: "string",
                                                            headerClassName: "header_grid",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            align: "center",
                                                        },
                                                        {
                                                            field: "vep_data_solicitacao",
                                                            headerName: "Dt. Criação Envio",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 140,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                        {
                                                            field: "fas_nome",
                                                            headerName: "Fase",
                                                            type: "string",
                                                            headerClassName: "header_grid",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            align: "center",
                                                        },
                                                    ]}
                                                />
                                            </ThemeProvider>
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Pagina
                authState={authState}
                Content={Content}
                HeaderDesc="SITUAÇÃO UPLOAD"
            />
        </Fragment>
    );
}
